export default __webpack_public_path__ + "static/media/dcorr_functions.b3e60358.png";